import React, { useState } from "react"
import PropTypes from "prop-types"
import Pill from "../../ui/Pill"
import { useSelector } from "react-redux"
import { selectAstrositesById } from "./slice"
import Dialog from "../../ui/Dialog"
import Button from "../../ui/Button"
import styled from "styled-components"
import FormGroup from "../../ui/FormGroup"
import Input from "../../ui/Input"

const Container = styled.span`
  cursor: pointer;
  min-width: 4rem;
  display: inline-block;
`

/** Manages a selection of Astrosites as compact "pills" - with the ability to add/remove
 * items from the selection. */
const CompactSelector = ({ value, onChange }) => {
  // Astrosites info
  const astrositesById = useSelector(selectAstrositesById)
  if (onChange) {
    // ...
  }

  // Alphabetical list
  const astrosites = Object.values(astrositesById)

  // Modal dialog to edit - it's the only space-efficient option
  // Changes are made in local state, and then propagated once applied
  const [selected, setSelected] = useState(value || [])
  const [isOpen, setIsOpen] = useState(false)

  const toggleSelected = (e) => {
    if (e.target.checked) {
      setSelected([...selected, e.target.value])
    } else {
      setSelected(selected.filter((i) => i != e.target.value))
    }
  }

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const apply = () => {
    onChange(selected)
    closeModal()
  }

  return (
    <>
      <Container onClick={openModal} title="Click to select astrosites">
        {value &&
          value.map((id) => {
            const astrosite = astrositesById[id]
            return (
              <Pill key={id} fgCol={astrosite?.color}>
                {id}
              </Pill>
            )
          })}
        {(value == null || value.length == 0) && (
          <Pill fgCol="#666" bgCol="#333">
            {" "}
            none{" "}
          </Pill>
        )}
      </Container>
      <Dialog
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Select Astrosites"
      >
        <h2>Select astrosites</h2>
        {astrosites.map(({ name, id }) => (
          <FormGroup key={id}>
            <label>
              <Input
                type="checkbox"
                value={id}
                checked={selected.includes(id)}
                onChange={toggleSelected}
              />{" "}
              {name}
            </label>
          </FormGroup>
        ))}
        <Button onClick={closeModal}>Cancel</Button>{" "}
        <Button onClick={apply}>Apply changes</Button>
      </Dialog>
    </>
  )
}

CompactSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string), // [AstrositeID]
  onChange: PropTypes.func,
}

export default CompactSelector
